// @flow

import React from 'react';
import { connect } from 'react-redux';
import { getKmPriceInEuros } from '../../../../store/pdb/selectors/model';
import Price from '../../../price';

type OwnProps = {|
  pdbId?: ?string, // eslint-disable-line react/no-unused-prop-types
  blocksPerRow: number, // eslint-disable-line react/no-unused-prop-types
  variant: string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  kmPrice: number,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const KmPrice = ({ kmPrice }: Props) => (
  <Price amount={kmPrice} displayCurrencySymbol />
);

KmPrice.defaultProps = {
  pdbId: null,
};

const mapStateToProps = (state, { pdbId }: OwnProps): StateProps => ({
  kmPrice: getKmPriceInEuros(state, pdbId),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(KmPrice);
